<template>
  <Row class="row-item" :gutter="12">
    <Col span="2" class="col-item">
      <span class="item-field">{{ description }}({{ len }}/{{ max }})</span>
    </Col>
    <Col span="12">
      <div class="c-smart-title">
        <div class="c-smart-title__item" v-for="(item, i) in data" :key="i">
          <creat-title
            v-model="item[item.name]"
            smart
            :name="item.name"
            :words="words"
            :description="description"
            :min="item.restriction.min_length"
            :max="item.restriction.max_length"
            :required="item.required"
            :verify="verify"
          />
          <div class="add-document" v-if="!i">
            <Button type="primary" :disabled="len >= max" @click="$emit('on-select', { max: max - len, name, type: 'smart' })"
              >选择文案</Button
            >
          </div>
          <div class="m-trash" v-if="trash">
            <Icon type="ios-trash" size="25" color="#ff635c" @click.stop="$emit('on-delete', i)" />
          </div>
        </div>
        <el-button v-if="len !== max" type="text" @click="$emit('on-add')">+添加计划语</el-button>
      </div>
    </Col>
  </Row>
</template>
<script>
import CreatTitle from './creat-title'
export default {
  name: 'smartTitle',
  components: { CreatTitle },
  props: {
    data: {
      type: Array
    },
    name: {
      type: String
    },
    words: {
      type: Array
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 3
    },
    description: {
      type: String,
      default: ''
    },
    sceneId: {
      type: Number
    },
    verify: {
      type: Boolean
    }
  },
  computed: {
    len() {
      return this.data.length
    },
    trash() {
      return this.len > 1
    }
  }
}
</script>
<style lang="scss" scoped>
.c-smart-title {
  .c-smart-title__item {
    position: relative;

    .add-document {
      position: absolute;
      top: 0;
      left: 425px;
    }

    .m-trash {
      position: absolute;
      line-height: 32px;
      top: -6px;
      left: 334px;
      cursor: pointer;
    }
  }
}

.row-item {
  align-items: flex-start;

  span.item-field {
    height: 32px;
    line-height: 32px;
  }
}
</style>
